import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n-composable'
import { openLandbotChat } from '@/components/landbot/composables/useLandbot'
import { TrackerEvents, trackEvent } from '@/plugins/tracker'

// TRANSLATIONS

export default /*#__PURE__*/_defineComponent({
  __name: 'ChatOnlineCardComponent',
  emits: ['close'],
  setup(__props, { emit: emits }) {

const { t } = useI18n()
const text = {
  title: t('components.dialog.support_service.chat_online.title'),
  start: t('components.dialog.support_service.chat_online.start'),
  contact: t('components.dialog.support_service.chat_online.contact')
}

// EVENTS


const closeModal = () => {
  emits('close')
}

// METHODS
const launchChat = () => {
  openLandbotChat()
  trackEvent(TrackerEvents.LAUNCH_LANDBOT)
  closeModal()
}

return { __sfc: true,t, text, emits, closeModal, launchChat }
}

})